import { useEffect, useState } from 'react'

// De `public/`, nao importada por webpack: assim tem nome estavel e pode ser
// pre-carregada pelo <link rel="preload"> do index.html. O service worker
// tambem a inclui no precache (__WB_MANIFEST), entao nas visitas seguintes
// vem do cache, sem rede.
const logoWithName = process.env.PUBLIC_URL + '/logo-app.png'

/**
 * Resolve a imagem do negocio, caindo na logo do app quando a url vem nula
 * ou quebrada.
 *
 * `background-image` do CSS nao dispara evento de erro, entao a carga e
 * testada aqui, fora do DOM.
 *
 * Receba a URL como string (`business?.url`), nunca o objeto `business`: ele
 * troca de identidade a cada resposta da API e faria o efeito reexecutar sem
 * a url ter mudado.
 *
 * @param {string | null | undefined} businessLogoUrl
 * @returns {{ logoUrl: string, isFallback: boolean }}
 */
function useBusinessLogo(businessLogoUrl) {

  // Inicializacao preguicosa: quando a url ja e conhecida como ausente no
  // primeiro render, o fallback vale desde a primeira pintura. Comecar em
  // `false` fazia a tela pintar o placeholder e so depois trocar pela logo,
  // porque o efeito so roda apos a montagem.
  const [failed, setFailed] = useState(() => !businessLogoUrl)

  useEffect(() => {

    if (!businessLogoUrl) {
      setFailed(true)
      return
    }

    // O estado so e escrito nos callbacks do probe: um reset otimista antes
    // de testar faria a imagem piscar de volta a cada reexecucao.
    // `cancelled` evita que um probe antigo, que so responde depois da troca
    // de negocio, sobrescreva o resultado do probe atual.
    let cancelled = false
    const probe = new Image()
    probe.onload = () => { if (!cancelled) setFailed(false) }
    probe.onerror = () => { if (!cancelled) setFailed(true) }
    probe.src = businessLogoUrl

    return () => { cancelled = true }

  }, [businessLogoUrl])

  return {
    logoUrl: failed ? logoWithName : businessLogoUrl,
    isFallback: failed
  }
}

export default useBusinessLogo
